<button type="button" class="btn" title="Filter Preset" [class.btn-warning]="filterApplied" [class.btn-primary]="!filterApplied" (click)="showFilters()">
    <span data-toggle="tooltip" class="fa fa-filter fa-lg"></span>
</button>

<div bsModal #presetFilter="bs-modal" class="modal fade" tabindex="-1" role="dialog" aria-labelledby="myModalLabel" aria-hidden="true" [config]="{ keyboard: false, backdrop: 'static' }">
    <div class="modal-dialog" style="width: 1000px;">
        <form (ngSubmit)="applyFilter()">
            <div class="modal-content">
                <div class="modal-header">
                    <button type="button" class="close" (click)="close()">&times;</button>
                    <h4 class="modal-title" id="myModalLabel">Filter Preset</h4>
                </div>
                <div class="modal-body">
                    <div class="row">
                        <div class="col-md-12">
                            <div class="input-group">
                                <div class="input-group-addon">
                                    <label>Preset Name</label>
                                </div>
                                <input name="FilterPreset" type="text" class="form-control" placeholder="Preset Name" [(ngModel)]="search" />
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-12">
                            <hr />
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-12">
                            <div class="input-group">
                                <div class="input-group-addon">
                                    <label>Preset</label>
                                </div>
                                <select name="selectedPresets" class="form-control" size="10" [(ngModel)]="selectedPresets">
                                    <option *ngFor="let preset of presets" [value]="preset.Id">{{ preset.PresetName }}</option>
                                </select>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-12">
                            <hr />
                        </div>
                    </div>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-success" *ngIf="filterApplied" (click)="clearFilter()">Clear Filter</button>
                    <button type="submit" class="btn btn-default">Apply Filter</button>
                </div>
            </div>
        </form>
    </div>
</div>